<p>players-league-admin-view works!</p>
